import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UnderConstructionPageComponent } from '@core/pages/under-construction-page.component';
import { NotFoundPageComponent } from '@core/pages/not-found-page.component';
import { AuthorizationDeniedPageComponent } from '@core/pages/authorization-denied-page.component';
//import { LoginPageCompoanent } from './features/login/pages/login-page.component';
import { AuthGuard } from '@core/guards/auth.guard';
import { OrdersDetailsPageComponent } from './features/orders-details/pages/orders-details-page.component';

const routes: Routes = [

    {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule),
    },
    // {
    //   path: '',
    //   component: LoginComponent,
    //   data: {
    //     url: '/login',
    //     title: 'Login page',
    //     icon: 'security',
    //     show: true,
    //     seq: 1
    //   }
    // },
    {
        path: 'authorization-denied',
        component: AuthorizationDeniedPageComponent,
        data: {
            url: '/authorization-denied',
            title: 'Authorization Denied',
            icon: 'security',
            show: true,
            seq: 6
        }
    },
    {
        path: 'under-construction',
        component: UnderConstructionPageComponent,
        data: {
            url: '/under-construction',
            title: 'Under Construction',
            icon: 'warning',
            show: true,
            seq: 4
        }
    },
    {
        path: 'not-found',
        component: NotFoundPageComponent,
        data: {
            url: '/not-found',
            title: 'Not Found',
            icon: 'sms_failed',
            show: true,
            seq: 5
        }
    },
    {
        path: '',
        redirectTo: '/products?category=home',
        pathMatch: 'full'
    },
    {
        path: 'featured',
        redirectTo: '/products?category=featured',
        pathMatch: 'full'
    },
    {

        path: 'register-account',
        loadChildren: () => import('./features/register-account/register-account.module').then(m => m.RegisterAccountModule),
        data: {
            url: '/register-account',
            title: 'Register Account',
            icon: 'home'
        }
    },
    {

        path: 'products',
        loadChildren: () => import('./features/products/products.module').then(m => m.ProductsModule),
        data: {
            url: '/products',
            title: 'Products Page',
            icon: 'home'
        }
    },
    {
        path: 'orders-history/:id',
        component: OrdersDetailsPageComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'orders-history/:id',
                loadChildren: () => import('./features/orders-details/orders-details.module').then(m => m.OrdersDetailsModule),
                data: {
                    url: '/orders-history/:id',
                    title: 'Orders Details Page',
                    icon: 'home'
                }
            },

        ]
    },
    {
        path: ':returnUrl/:returnUrl',
        loadChildren: () => import('./features/login/login.module').then(m => m.LoginModule),
        data: {
            url: ':category/:productCode',
            title: 'Product Page',
            icon: 'home'
        }
    },
    {
        path: 'checkout',
        loadChildren: () => import('./features/checkout/checkout.module').then(m => m.CheckoutModule),
        data: {
            url: '/checkout',
            title: 'Checkout Page',
            icon: 'home',
            show: true,
            seq: 1
        }
    },
    {
        path: 'login',
        loadChildren: () => import('./features/login/login.module').then(m => m.LoginModule),
        data: {
            url: '/login',
            title: 'Login Page',
            icon: 'home',
            show: true,
            seq: 1
        }
    },
    {
        path: 'wish-list',
        loadChildren: () => import('./features/wish-list/wish-list.module').then(m => m.WishlistModule),
        data: {
            url: '/wish-list',
            title: 'Wish List Page',
            icon: 'home'
        }
    },
    {
        path: 'cart',
        loadChildren: () => import('./features/cart/cart.module').then(m => m.CartModule),
        data: {
            url: '/cart',
            title: 'Cart Page',
            icon: 'home',
            show: true,
            seq: 1
        }
    },
    {
        path: 'contact',
        loadChildren: () => import('./features/contact/contact.module').then(m => m.ContactModule),
        data: {
            url: '/contact',
            title: 'Contact Page',
            icon: 'home',
            show: true,
            seq: 1
        }
    },
    {
        path: 'access-to-information',
        loadChildren: () => import('./features/access-to-information/access-to-information.module').then(m => m.AccessToInformationModule),
        data: {
            url: '/access-to-information',
            title: 'Access To Information Page',
            icon: 'home',
            show: true,
            seq: 1
        }
    },
    {
        path: 'terms-and-conditions',
        loadChildren: () => import('./features/terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule),
        data: {
            url: '/terms-and-conditions',
            title: 'Terms And Conditions Page',
            icon: 'home',
            show: true,
            seq: 1
        }
    },
    {
        path: 'addresses',
        loadChildren: () => import('./features/addresses/addresses.module').then(m => m.AddressesModule),
        data: {
            url: '/addresses',
            title: 'Addresses Page',
            icon: 'home',
            show: true,
            seq: 1
        }
    },
    {
        path: 'account-dashboard',
        loadChildren: () => import('./features/account-dashboard/account-dashboard.module').then(m => m.AccountDashboardModule),
        data: {
            url: '/account-dashboard',
            title: 'Account Dashboard Page',
            icon: 'home',
            show: true,
            seq: 1
        }
    },
    {
        path: 'orders-history',
        loadChildren: () => import('./features/orders-history/orders-history.module').then(m => m.OrdersHistoryModule),
        data: {
            url: '/orders-history',
            title: 'Orders History Page',
            icon: 'home',
            show: true,
            seq: 1
        }
    },

    {
        path: '**',
        redirectTo: 'not-found',
        pathMatch: 'full'
    }
];



@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
